import AccountOptionType from "./AccountOptionType";

class AccountOptionTypes {

  constructor(private readonly _list: AccountOptionType[] = []) {
  }

  public hasReservation(): boolean {
    return this._list.some((option: AccountOptionType) => option === AccountOptionType.RESERVATION);
  }

  public hasRecord(): boolean {
    return this._list.some((option: AccountOptionType) => option === AccountOptionType.RECORD);
  }

  public hasCustomerCsvExport(): boolean {
    return this._list.some((option: AccountOptionType) => option === AccountOptionType.CUSTOMER_CSV_EXPORT);
  }

  public hasEmailSendLimitUnlimited(): boolean {
    return this._list.some((option: AccountOptionType) => option === AccountOptionType.EMAIL_SEND_LIMIT_UNLIMITED);
  }

  public hasEmailSendLimit1000(): boolean {
    return this._list.some((option: AccountOptionType) => option === AccountOptionType.EMAIL_SEND_LIMIT_1000);
  }

  public hasEmailSendLimit500(): boolean {
    return this._list.some((option: AccountOptionType) => option === AccountOptionType.EMAIL_SEND_LIMIT_500);
  }

  public getMailSendOption(): AccountOptionType.EMAIL_SEND_LIMIT_500 | AccountOptionType.EMAIL_SEND_LIMIT_1000 | AccountOptionType.EMAIL_SEND_LIMIT_UNLIMITED {
    switch (this._list.find(value => value === AccountOptionType.EMAIL_SEND_LIMIT_500 || value === AccountOptionType.EMAIL_SEND_LIMIT_1000 || value === AccountOptionType.EMAIL_SEND_LIMIT_UNLIMITED)) {
      default:
      case AccountOptionType.EMAIL_SEND_LIMIT_500:
        return AccountOptionType.EMAIL_SEND_LIMIT_500;
      case AccountOptionType.EMAIL_SEND_LIMIT_1000:
        return AccountOptionType.EMAIL_SEND_LIMIT_1000;
      case AccountOptionType.EMAIL_SEND_LIMIT_UNLIMITED:
        return AccountOptionType.EMAIL_SEND_LIMIT_UNLIMITED;
    }
  }

  get list(): AccountOptionType[] {
    return this._list;
  }
}

export default AccountOptionTypes;